import { getRecordsForCompositeTargetCollection } from '../../reducers/standard_reducer_utils';
import {
	getCurrency,
	nullSafeGetOrElse,
	valueCompareWithoutType,
} from '../../utils/DataAccessUtils';
import { LIMIT_ONE_PAGINATION, WO_STEP_NAMES } from '../../utils/DataConstants';

export interface LOCATION_STEP_PROPS {
	fetchAreasTopLevel: any;
	goNextAfterBriefPause: any;
	locations: any;
	TC_NAME: string;
	fetchLocation: any;
	currentUser: any;
	fetchExchangeRate: any;
	setState: any;
	resetFieldAFter: any;
}

const getLocationObject = (args: LOCATION_STEP_PROPS) => (locationId) => {
	const { locations, TC_NAME, fetchLocation } = args;
	const locationRecords = getRecordsForCompositeTargetCollection(locations, TC_NAME);

	const location = locationRecords.find(({ id }) => valueCompareWithoutType(id, locationId));
	if (location) {
		return Promise.resolve(location);
	}

	return fetchLocation(locationId);
};

const handleBuyerCurrencyToLocationExchangeRate = (args: LOCATION_STEP_PROPS) => (location) => {
	const { currentUser, fetchExchangeRate, setState } = args;
	const locationCurrencyId = getCurrency({ location }).id;
	const buyerCurrencyId = getCurrency({ currentUser }).id;
	if (locationCurrencyId !== buyerCurrencyId) {
		fetchExchangeRate(locationCurrencyId, buyerCurrencyId, currentUser.contactType).then((rate) => {
			setState({
				currencyExchangeRateBuyerToLocation: nullSafeGetOrElse('conversionRate', rate, 1),
			});
		});
	} else {
		setState({ currencyExchangeRateBuyerToLocation: 1 });
	}
};

export const handleLocationClick = (args) => (locationId, ignoreTroubleshooting) => {
	const { fetchAreasTopLevel, goNextAfterBriefPause, locations, TC_NAME } = args;
	const locationRecords = getRecordsForCompositeTargetCollection(locations, TC_NAME);
	const location = locationRecords.find(({ id }) => valueCompareWithoutType(id, locationId));
	fetchAreasTopLevel({
		locationId,
		...(location && location.locationTypeId && { locationTypeId: location.locationTypeId }),
	}).then((areas) => {
		if (areas && areas.length > 0) {
			goNextAfterBriefPause(
				[],
				WO_STEP_NAMES.AREA_TOP_LEVEL,
				WO_STEP_NAMES.LOCATIONS,
				ignoreTroubleshooting
			);
		} else {
			goNextAfterBriefPause(
				[],
				WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
				WO_STEP_NAMES.LOCATIONS,
				ignoreTroubleshooting
			);
		}
	});
};

export const handleLocation = (args: LOCATION_STEP_PROPS) => (locationId) => {
	const {
		fetchAreasTopLevel,
		resetFieldAFter,
		setState,
		goNextAfterBriefPause,
		locations,
		TC_NAME,
	} = args;
	const locationRecords = getRecordsForCompositeTargetCollection(locations, TC_NAME);
	const location = locationRecords.find(({ id }) => valueCompareWithoutType(id, locationId));

	const areasPromise = fetchAreasTopLevel(
		{
			locationId,
			...(location && location.locationTypeId && { locationTypeId: location.locationTypeId }),
		},
		null,
		LIMIT_ONE_PAGINATION
	);
	const locationPromise = getLocationObject(args)(locationId);
	resetFieldAFter('locations');
	Promise.all([areasPromise, locationPromise]).then(([areas, location]) => {
		handleBuyerCurrencyToLocationExchangeRate(args)(location);
		setState({ location, areas }, () => {
			if (areas && areas.length > 0) {
				goNextAfterBriefPause([], WO_STEP_NAMES.AREA_TOP_LEVEL, WO_STEP_NAMES.LOCATIONS);
			} else {
				goNextAfterBriefPause([], WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL, WO_STEP_NAMES.LOCATIONS);
			}
		});
	});
};
